import api from "@/api";
const CurrentModule = {
    state: () => ({
        song: {},
        playedSongs: [] // Track played songs history
    }),
    mutations: {
        UPDATE_SONG(state, payload) {
            state.song = payload;
        },
        ADD_TO_PLAYED_SONGS(state, payload) {
            // Add song to played history, avoid duplicates at the front
            const existingIndex = state.playedSongs.findIndex(song => song.id === payload.id);
            if (existingIndex !== -1) {
                // Remove existing entry
                state.playedSongs.splice(existingIndex, 1);
            }
            // Add to the beginning
            state.playedSongs.unshift({
                ...payload,
                playedAt: new Date().toISOString()
            });
            // Keep only last 50 played songs
            if (state.playedSongs.length > 50) {
                state.playedSongs = state.playedSongs.slice(0, 50);
            }

            // Save to localStorage
            try {
                localStorage.setItem('nomad_played_songs', JSON.stringify(state.playedSongs));
            } catch (error) {
                console.error('Error saving to localStorage:', error);
            }
        },
        LOAD_PLAYED_SONGS(state) {
            // Load from localStorage on app init
            try {
                const stored = localStorage.getItem('nomad_played_songs');
                if (stored) {
                    state.playedSongs = JSON.parse(stored);
                }
            } catch (error) {
                console.error('Error loading from localStorage:', error);
                state.playedSongs = [];
            }
        },
        CLEAR_PLAYED_SONGS(state) {
            state.playedSongs = [];
            localStorage.removeItem('nomad_played_songs');
        },
    },
    actions: {
        async prepareCurrent({ commit, dispatch }, payload) {
            const current = await api.CurrentApi.fetchSong(payload);
            let { mp3, sources } = current.data.data

            if (payload.stream) {
                current.data.data.stream = payload.stream
            }

            if (mp3) {
                commit("UPDATE_SONG", current.data.data);
                // Add to played songs history
                commit("ADD_TO_PLAYED_SONGS", current.data.data);
            }
            else {
                dispatch('notification/showNotification', { message: "content not available", type: "info" }, { root: true })
            }
        },
        loadPlayedSongs({ commit }) {
            commit("LOAD_PLAYED_SONGS");
        },
        clearPlayedSongs({ commit }) {
            commit("CLEAR_PLAYED_SONGS");
        },
    },
    getters: {
        currentSong(state) {
            return state.song;
        },
        playedSongs(state) {
            return state.playedSongs;
        },
        recentlyPlayed(state) {
            return state.playedSongs.slice(0, 10); // Get last 10 played songs
        },
    },
    namespaced: true,
};

export default CurrentModule;
